<template>
  <div class="mw-container w-100" :data-type="type">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'MaxWidthContainer',
  props: {
    type: {
      type: String,
      required: false,
      default: 'normal'
    }
  }
}
</script>

<style lang="scss" scoped>
  .mw-container {
    max-width: 1440px;
    margin: 0 auto;

    &[data-type='wide'] {
      max-width: 1880px;
    }
  }
</style>
